<template>
    <div class="vip_main">
        <div></div>
        <div id="main_body">
            <van-popup
                get-container="#main_body"
                v-model="show"
                round
                position="top"
                :style="{ height: '50%' }"
            >
                <van-picker v-show="showGame"
                            show-toolbar :columns="gameOptions"
                            @cancel="onCancelGame"
                            @confirm="onConfirmGame">
                    <div slot="title">
<!--                        <van-search-->
<!--                            v-model="queryGame"-->
<!--                            placeholder="搜索游戏"-->
<!--                            style="width: 14.5rem"-->
<!--                            @input="onInput"-->
<!--                        />-->
                    </div>
                    <template #option="option">
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <div>{{ option.label }}</div>
                        </div>
                    </template>
                </van-picker>
                <van-picker v-show="showServer"
                            show-toolbar :columns="servers"
                            @cancel="onCancel"
                            @confirm="onConfirm">
                    <div slot="title">
                        <van-search
                            v-model="query"
                            placeholder="搜索游戏区服"
                            style="width: 14.5rem"
                            @input="onInput"
                        />
                    </div>
                    <template #option="option">
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <div>{{ option.label }}</div>
                        </div>
                    </template>
                </van-picker>
            </van-popup>
            <div class="vip_search">
<!--                <div style="font-size: 14px;"> {{ currentSelect }}</div>-->
                <van-button color="#ee3a3a" class="search_btn" round plain @click="openPopup('game')">{{ currentSelectGame }}</van-button>
                <van-button color="#ee3a3a" class="search_btn" round plain @click="openPopup('server')">{{ currentSelect }}</van-button>
            </div>
            <table class="vip_table">
                <thead>
                    <tr>
                        <th>vip等级</th>
                        <th>达到人数</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="tableData.length > 0" v-for="item in tableData">
                        <td> {{ item.level }}</td>
                        <td> {{ item.num }}</td>
                    </tr>
                    <tr v-if="tableData.length <= 0">
                        <td colspan="2" style="height: 120px;color: #aaa;">
                            暂无数据
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div></div>
    </div>
</template>

<script>
import {get} from "@/api/request";

export default {
    name: "VipLevel",
    data() {
        return {
            show: false,
            showGame: false,
            showServer: false,
            servers: [],
            gameOptions: [
                {label: '黄金灵眸服', value: '1008'},
                {label: '青春灵眸服', value: '1013'},
            ],
            query: '',
            queryGame: '',
            tableData: [],
            currentSelect: '选择区服',
            currentSelectGame: '选择游戏',
            currentSelectGameId: '',
        }
    },
    mounted() {
        this.currentSelectGame = this.gameOptions[0].label;
        this.currentSelectGameId = this.gameOptions[0].value;
        const unwatch = this.$watch('servers', function(newValue, oldValue){
            if(!this.currentSelectGame || this.currentSelectGame === "选择游戏") {
                this.$toast("请先选择游戏");
                return;
            }
            this.currentSelect = this.servers[0].label;
            this.getServerVipLevel(this.currentSelectGameId, this.servers[0].value);
            unwatch();
        });
        this.searchServer();
        this.onInput = this.throttle(this.onInput.bind(this), 800);
    },
    methods: {
        getServerVipLevel(g, s) {
            get(`/h5/queryServerVipLevel?g=${g}&s=${s}`).then(res => {
                if(res.data.data) {
                    this.tableData = res.data.data;
                } else {
                    this.tableData = [];
                }
            })
        },
        searchServer() {
            get(`/h5/queryServer?g=${this.currentSelectGameId}&s=${this.query}`).then(res => {
                if(res.data.data) {
                    this.servers = res.data.data;
                }else {
                    this.servers = [];
                }
            })
        },
        throttle(func, delay) {
            let timeoutId
            let lastExecTime = 0
            const throttled = function (...args) {
                const currentTime = Date.now()

                if (currentTime - lastExecTime > delay) {
                    func.apply(this, args)
                    lastExecTime = currentTime
                } else {
                    clearTimeout(timeoutId)
                    timeoutId = setTimeout(() => {
                        func.apply(this, args)
                        lastExecTime = Date.now()
                    }, delay - (currentTime - lastExecTime))
                }
            }
            return throttled
        },
        openPopup(type) {
            this.show = true;
            this.showGame = type === 'game';
            this.showServer = type === 'server';
        },
        onInput(value) {
            this.searchServer();
        },
        onCancel() {
            this.query = '';
            this.show = false;
        },
        onConfirm(value, index) {
            if(!this.currentSelectGame || this.currentSelectGame === "选择游戏") {
                this.$toast("请先选择游戏");
                return;
            }
            this.currentSelect = value.label;
            this.getServerVipLevel(this.currentSelectGameId, value.value);
            this.show = false;
        },
        onCancelGame() {
            this.queryGame = '';
            this.show = false;
        },
        onConfirmGame(value, index) {
            if(value.value !== this.currentSelectGameId) {
                this.currentSelect = '选择区服';
                this.servers = [];
                this.currentSelectGameId = value.value;
                this.searchServer();
            }
            this.currentSelectGame = value.label;
            this.currentSelectGameId = value.value;
            this.show = false;
        },
    }
}
</script>

<style scoped>
    .vip_main {
        height: 100%;
        margin: 20px;
        display: grid;
        grid-template-columns: 25% 50% 25%;
    }
    .vip_table {
        width: 100%;
        border: 1px solid #cbcbcb;
        border-collapse: collapse;
        margin-top: 10px;
    }
    .vip_table th, td {
        border: 1px solid #cbcbcb;
        color: #252525;
        height: 30px;
    }
    .vip_table th {
        background-color: #f2f2f2;
        height: 40px;
    }
    .vip_search {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .search_btn {
        height: 35px;
        line-height: 35px;
    }

    @media screen and (max-width: 500px) {
        .vip_main {
            grid-template-columns: 5% 90% 5%;
        }
    }
</style>